angular.module('impactx.rfx').controller('RFXSupplierHeaderCtrl', [
    'dataGen',
    'ToastService',
    'TranslationService',
    '$mdDialog',
    'RFXSupplierService',
    'ColorUtilService',
    '$redirect',
    'RFQSearchService',
    RFXSupplierHeaderController
]);

function RFXSupplierHeaderController(dataGen, ToastService, TranslationService, $mdDialog, RFXSupplierService, ColorUtilService, $redirect, RFQSearchService) {
    var self = this;

    self.offSetForBasketItemGroupColor = 15;
    self.getGroupColor = function (item) {
        if (item.basketItemGroupId) {
            return ColorUtilService.getColor(item.basketItemGroupId + self.offSetForBasketItemGroupColor);
        }
        return 'transparent';
    }

    self.extendBorderBasketItemGroup = function (item) {
        var id = item.basketItemGroupId || 0;
        var element = document.getElementsByClassName('basket-item-group-' + (id + self.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    self.shrinkBorderBasketItemGroup = function (item) {
        var id = item.basketItemGroupId || 0;
        var element = document.getElementsByClassName('basket-item-group-' + (id + self.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    self.isInformation = function (item) {
        var policy;
        if (item.smartForm) {
            policy = RFXSupplierService.getSmartFormPolicy(item.smartForm.identifier, self.rfqHeader.smartFormPolicies);
        }
        return item.isInformation || (policy && policy.isInformation);
    };

    self.showPrice = function (item) {
        var policy;
        if (item.smartForm) {
            policy = RFXSupplierService.getSmartFormPolicy(item.smartForm.identifier, self.rfqHeader.smartFormPolicies);

        }
        else if (item.sfiIdentifier) {
            policy = RFXSupplierService.getSmartFormPolicy(item.sfiIdentifier, self.rfqHeader.smartFormPolicies);
        }
        return !item.isInformation && !(policy && (policy.isInformation || policy.priceOnOrder));
    };

    self.select = function () {
        var index = self.selectedContracts.indexOf(self.contract);
        if (index < 0) {
            self.selectedContracts.push(self.contract);
            self.selectedItems.length = 0;
            self.selectedConditions.length = 0;
        }
        else {
            self.selectedContracts.splice(index, 1);
        }
    }

    self.selectPosition = function (position) {
        var index = self.selectedItems.indexOf(position);
        if (index < 0) {
            self.selectedItems.push(position);
            self.selectedContracts.length = 0;
            self.selectedConditions.length = 0;
        }
        else {
            self.selectedItems.splice(index, 1);
        }
    };

    self.selectCondition = function (event, condition) {
        var index = self.selectedConditions.indexOf(condition);
        if (index < 0) {
            self.selectedConditions.push(condition);
            self.selectedContracts.length = 0;
            self.selectedItems.length = 0;
        }
        else {
            self.selectedConditions.splice(index, 1);
        }
        event.stopPropagation();
    }

    self.isContractSelected = function () {
        return self.selectedContracts.indexOf(self.contract) >= 0;
    }

    self.isSelected = function (item) {
        return self.selectedItems.indexOf(item) >= 0;
    };

    self.isConditionSelected = function (condition) {
        return self.selectedConditions.indexOf(condition) >= 0;
    }

    self.editBasketItemGroup = function (event, item) {
        var basketItemGroupId = item.basketItemGroupId;
        var groupItems = findBasketItemGroupItems(item.basketItemGroupId);
        RFXSupplierService.showFreeformOfferDialog(event, item.basketItemGroupId, self.rfqHeader.id, self.rfqHeader.supplierId,
            groupItems, item.basketItemGroupData, self.contract.id, self.contract.lotId, undefined, [self.contract]).then(function (data) {
            if (data && data.requestItems && !data.completeOffer) {
                RFXSupplierService.updateItemList(data.requestItems, self.rfqHeader.id).then(function (updatedData) {
                    if (impactX.isDefined(updatedData, 'data.itemList') && updatedData.data.itemList.length > 0) {
                        var j = 0;
                        var toRemoveIndexes = [];
                        for (var i = 0; i < self.contract.items.length; i++) {
                            if (self.contract.items[i].basketItemGroupId === basketItemGroupId) {
                                if (updatedData.data.itemList.length > j) {
                                    self.contract.items[i] = updatedData.data.itemList[j++];
                                }
                                else {
                                    toRemoveIndexes.push(i);
                                }
                            }
                        }
                        for (var l = 0; l < toRemoveIndexes.length; l++) {
                            self.contract.items.splice(toRemoveIndexes[0], 1);
                        }
                        if (j < updatedData.data.itemList.length) {
                            for (var k = j; k < updatedData.data.itemList.length; k++) {
                                self.contract.items.push(updatedData.data.itemList[k]);
                            }
                        }
                    }
                    RFXSupplierService.restoreItemListComments(self.contract.items);
                    self.onChange({contract: self.contract});
                });
            }
        });
    }

    self.deleteBasketItemGroup = function (event, basketItemGroupId) {
        var groupItems = findBasketItemGroupItems(basketItemGroupId);
        if (groupItems) {
            self.deletePositions({event: event, items: groupItems});
        }
    }

    function findBasketItemGroupItems (identifier) {
        return self.contract.items.filter(function (item) {
            return item.basketItemGroupId === identifier;
        });
    }

    self.redirectToProduct = function (event, productId) {
        event.stopPropagation();
        if (self.canAddProductPosition()) {
            RFQSearchService.activateRFQSSearch(self.getProductSelectionParams(), "product/" + productId + "/true", !self.canEdit());
        }
        else {
            $redirect.redirectTo(null, "product/" + productId + "/true");
        }
    };
}